import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import * as Sentry from '@sentry/react';

import reducers from 'state/reducers';
import sagas from 'state/sagas';
import { captureError } from 'sentry';

const history = createBrowserHistory();

const sagaMiddleWare = createSagaMiddleware({
  onError: (error) => {
    captureError(error);
  },
});

const composeEnhancers = composeWithDevTools({
  trace: true,
  traceLimit: 35,
});

const historyMiddleware = routerMiddleware(history);

const middlewares = [historyMiddleware, sagaMiddleWare];
const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const getStore = () => {
  const store = createStore(
    reducers(history),
    composeEnhancers(applyMiddleware(...middlewares), sentryReduxEnhancer)
  );

  sagaMiddleWare.run(sagas);

  const persistor = persistStore(store);

  return { store, persistor, history };
};

export default getStore;
export { history };
